const UTM_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'msclkid',
  'fbclid',
  'utm_id',
  'gbraid',
  'wbraid',
  'ttclid',
  'li_fat_id',
  'dclid',
  'gclsrc',
];

export function getUtmParamsFromUrl(url: string): Record<string, string> {
  const urlParams = new URLSearchParams(url);

  return UTM_PARAMS.reduce((acc, param) => {
    if (urlParams.has(param)) {
      acc[param] = urlParams.get(param) as string;
    }
    return acc;
  }, {} as Record<string, string>);
}
